import { Link } from 'react-router-dom'

interface Props {
  message?: string
}

export default function AccessDenied({
  message = 'You are signed in, but your account does not have permission to access this page.',
}: Props) {
  return (
    <div
      role="alert"
      style={{
        padding: 24,
        color: '#8e1b1b',
        background: '#fdecea',
        border: '1px solid #f5c2c0',
        borderRadius: 6,
      }}
    >
      <h1 style={{ margin: '0 0 8px', fontSize: 20 }}>Access denied</h1>
      <p style={{ margin: '0 0 16px', color: '#5d2929', fontSize: 14 }}>{message}</p>
      <Link to="/nodes" style={{ color: '#3949ab', fontSize: 13 }}>
        Return to Nodes
      </Link>
    </div>
  )
}
